import { Button } from '@sravni/react-design-system/lib/Button';

import { VkVideoLink } from '../constants';
import { HeaderTitle } from '../HeaderTitle';
import { OctoberPrizeDrawLayout } from '../OctoberPrizeDrawLayout';

import { MainWinner } from './components/MainWinner';
import { OtherWinners } from './components/OtherWinners';
import { SecondaryWinners } from './components/SecondaryWinners';
import { useWinnersData } from './hooks/useWinnerData';
import styles from './styles.module.scss';

export const OctoberPrizeDrawPrizeWinners = () => {
  const { winnerList, buttonText, toggleWinnersList } = useWinnersData();

  return (
    <OctoberPrizeDrawLayout>
      <div className={styles.container}>
        <HeaderTitle
          title="Поздравляем победителей!"
          subTitle={<>Мы разыграли призы случайным образом при помощи {VkVideoLink}</>}
        />

        <MainWinner />

        <SecondaryWinners />

        <OtherWinners items={winnerList} />

        <div className={styles.buttonWrapper}>
          <Button size={60} className={styles.button} onClick={toggleWinnersList}>
            {buttonText}
          </Button>
        </div>
      </div>
    </OctoberPrizeDrawLayout>
  );
};
